import { Heart, Zap, CheckCircle, QrCode } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from '@/hooks/useToast';
import { QRCodeSVG } from 'qrcode.react';

export function DonationSection() {
  const lightningAddress = 'panama@walletofsatoshi.com';
  const lnurlString = `lightning:${lightningAddress}`;

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-950 py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <Card className="overflow-hidden border-2 border-orange-200 dark:border-orange-800 bg-gradient-to-br from-white via-orange-50/20 to-amber-50/20 dark:from-gray-900 dark:via-orange-950/10 dark:to-amber-950/10">
            <div className="grid md:grid-cols-5 gap-8">
              {/* Left Column - Information (3 columns) */}
              <div className="md:col-span-3 p-8 md:p-10">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 mb-6 shadow-lg shadow-orange-500/30">
                  <Heart className="w-7 h-7 text-white fill-white" />
                </div>

                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white">
                  Apoya Nuestra Misión
                </h2>
                <p className="text-lg text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
                  Bitcoin Life Panamá es un proyecto educativo sin fines de lucro. Tu donación nos ayuda a:
                </p>

                <div className="space-y-3 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-950 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle className="w-4 h-4 text-orange-600 dark:text-orange-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        Crear más contenido educativo gratuito en español
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-950 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle className="w-4 h-4 text-orange-600 dark:text-orange-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        Organizar meetups y eventos comunitarios en Panamá
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-950 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle className="w-4 h-4 text-orange-600 dark:text-orange-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        Capacitar comercios para aceptar Bitcoin en Ciudad de Panamá
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-orange-100 dark:bg-orange-950 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle className="w-4 h-4 text-orange-600 dark:text-orange-400" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        Expandir la economía circular Bitcoin en Latinoamérica
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                  <Zap className="w-4 h-4 text-orange-600" />
                  <span>Todas las donaciones vía Lightning Network ⚡</span>
                </div>
              </div>

              {/* Right Column - Donation CTA (2 columns) */}
              <div className="md:col-span-2 bg-gradient-to-br from-orange-600 via-amber-600 to-yellow-600 p-8 md:p-10 flex flex-col justify-center items-center text-center relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjEpIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-20"></div>

                <div className="relative z-10 space-y-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm">
                    <Zap className="w-10 h-10 text-white" />
                  </div>

                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                      Dona con Bitcoin
                    </h3>

                    {/* QR Code */}
                    <div className="bg-white p-4 rounded-2xl shadow-2xl mb-4 inline-block">
                      <QRCodeSVG
                        value={lnurlString}
                        size={180}
                        level="H"
                        includeMargin={true}
                        fgColor="#000000"
                        bgColor="#ffffff"
                      />
                    </div>

                    <div className="flex items-center justify-center gap-2 mb-2">
                      <QrCode className="w-4 h-4 text-white/80" />
                      <p className="text-sm text-white/90">
                        Escanea con cualquier billetera Lightning
                      </p>
                    </div>

                    <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 mb-4">
                      <div className="text-xs text-white/70 mb-1">Lightning Address:</div>
                      <code className="text-sm text-white font-mono break-all">
                        {lightningAddress}
                      </code>
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 w-full">
                    <a
                      href="https://geyser.fund/project/bitcoinlifepanama"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full"
                    >
                      <Button
                        size="lg"
                        className="w-full bg-white text-orange-600 hover:bg-gray-100 shadow-xl h-12 px-8 text-base font-semibold group"
                      >
                        <Heart className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
                        Donar en Geyser
                      </Button>
                    </a>

                    <div className="relative">
                      <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-white/30"></div>
                      </div>
                      <div className="relative flex justify-center text-xs">
                        <span className="px-2 bg-gradient-to-br from-orange-600 via-amber-600 to-yellow-600 text-white/80">
                          o
                        </span>
                      </div>
                    </div>

                    <Button
                      size="lg"
                      variant="outline"
                      className="w-full border-2 border-white text-white hover:bg-white/10 h-12 px-8 text-base font-semibold"
                      onClick={() => {
                        navigator.clipboard.writeText('panama@walletofsatoshi.com');
                        toast({
                          title: '¡Copiado! ⚡',
                          description: 'Lightning address copiada al portapapeles',
                        });
                      }}
                    >
                      <Zap className="w-5 h-5 mr-2" />
                      Copiar Lightning Address
                    </Button>
                  </div>

                  <p className="text-xs text-white/70 mt-4">
                    Donaciones 100% destinadas a educación Bitcoin
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
